import { Col, Form, Input, Modal } from 'antd';
import { FC } from 'react';
import asyncErrorHandler from 'src/utils/asyncErrorHandler';

interface FeedbackModalProps {
  visible: boolean;
  loading: boolean;
  onConfirm: (values: Record<string, any>) => Promise<void>;
  onClose: () => void;
}

const { TextArea } = Input;

const FeedbackModal: FC<FeedbackModalProps> = ({
  visible,
  onConfirm,
  onClose,
  loading,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      open={visible}
      confirmLoading={loading}
      destroyOnClose
      onCancel={onClose}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onConfirm(values)
              .then(() => {
                form.resetFields();
              })
              .catch(() => {});
          })
          .catch((error) => {
            asyncErrorHandler(error);
          });
      }}
    >
      <Form layout="vertical" form={form}>
        <Col xs={24}>
          <Form.Item
            rules={[
              {
                required: true,
                message: 'This field is required',
              },
            ]}
            className="mb-0"
            label="Comment"
            name="approval_feedback"
          >
            <TextArea
              placeholder="Please provide a feedback about the modifications"
              rows={5}
            />
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  );
};

export default FeedbackModal;
